<script setup lang="ts">
import { ref, watch } from 'vue';

import DetailedJobInfoDescListItem from '@/components/items/DetailedJobInfoDescListItem.vue';
import { getPOD } from '@/api';

export interface Props {
  jobId?: number;
  jobDate?: string;
  stopNumber?: number;
  podName?: string | null;
  isPodImage?: boolean;
}
const props = withDefaults(defineProps<Props>(), {
  jobId: undefined,
  jobDate: undefined,
  stopNumber: undefined,
  podName: undefined,
  isPodImage: undefined,
});

const url = ref('');
const loading = ref(false);

watch(
  () => props,
  (newValue, oldValue) => {
    url.value = '';
    if (!props.isPodImage) return;
    if (!props.jobId) return;
    if (!props.jobDate) return;
    if (!props.stopNumber) return;
    loading.value = true;
    void getPOD(props.jobId, props.jobDate, props.stopNumber)
      .then((img) => {
        if (img !== 'Not found') url.value = img;
      })
      .finally(() => {
        loading.value = false;
      });
  },
  { immediate: true },
);
</script>

<template>
  <dl :class="$style.jobSignatureDescList" data-testid="jobSignatureDescList">
    <DetailedJobInfoDescListItem :class="$style.item" term="POD">
      <div :class="$style.wrapper">
        <div :class="$style.white">
          <img v-if="url" :src="url" :class="$style.img" />
          <template v-else-if="!loading">No signature</template>
          <v-progress-linear
            v-if="loading"
            indeterminate
            rounded
            height="4"
          ></v-progress-linear>
        </div>
        <div :class="$style.name">
          <template v-if="podName">{{ podName }}</template>
        </div>
      </div>
    </DetailedJobInfoDescListItem>
  </dl>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.jobSignatureDescList {
  line-height: 1.4;
  font-size: 16px;
  margin: 0;
}
  .wrapper {
    background-color: colors.$color-brand-50;
    padding: 1rem 2rem 0.5rem 2rem;
    text-align: right;
  }
    .white {
      font-size: 14px;
      background-color: colors.$color-white;
      height: 75px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0.5rem;
    }
      .img {
        max-width: 100%;
        max-height: 100%;
      }
    .name {
      margin-top: 6px;
    }
</style>
